export default "__VITE_ASSET__aFAsHGcA__"